import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Eqipment = ({
  onChange,
  disabled,
  error,
  title,
  equipment,
  equipment_types,
  gps_providers,
  addNewItem,
  removeItem,
  has_duplicated_key_boolean,
  fuel_providers,
  ...props
}) => {

  const handleChange = event => {
    onChange(event, 'equipment')
  }

  const handleAddItem = event => {
    event.preventDefault();
    event.stopPropagation();
    addNewItem('vehicle_equipment_type_ids');
  }

  const handleRemoveItem = (event, idx) =>{
    event.preventDefault();
    event.stopPropagation();
    removeItem('vehicle_equipment_type_ids', idx)
  }

  const classes = useStyles();

  const getEquipmentData = (id) => {
    if (id !== '' && id !== undefined && id !== null){
      var data = {}
      equipment_types.map((val, idx)=>{
        if (parseInt(val.id) === parseInt(id)) {
          data.name = val.name
        } 
      })
    }
    return data; 
  }

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      <FormControl className="mt-3 mr-2" style={{minWidth: 200, fontSize: '0.75rem'}} name='gps_provider_id' >Seleccione el proveedor de GPS
        <Select native name='gps_provider_id'
            inputProps={{
              name:"gps_provider_id",
              className:"gps_provider_id"
            }}
            style={{minWidth: 200, fontSize: '0.75rem'}}
            disabled={disabled}
            onChange={handleChange}
            value={equipment.gps_provider_id}
            error={(error !=='' && parseInt(equipment.gps_provider_id) > 1) ? 'El vehiculo no puede tener GPS al darse de baja' :  false }
            input={<Input id="grouped-native-select" name='gps_provider_id'/>}>
            <option value="" />
            {gps_providers.map((gps_provider) => <option id={gps_provider.id} value={gps_provider.id}>{gps_provider.name}
          </option>)}
        </Select> 
        {(error !=='' && parseInt(equipment.gps_provider_id) > 1) && <FormHelperText style={{color: 'red'}}>El vehiculo no puede tener GPS al darse de baja</FormHelperText>}        
      </FormControl>

{/*      <TextField
        id="gps_ammount"
        name="gps_ammount"
        label="Monto de GPS"
        disabled={disabled}
        error={(error !=='' && equipment.gps_ammount ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && equipment.gps_ammount ==='' ) ? 'Debe completar este valor' : ''}
        type="text"
        placeholder="Ingrese el monto de GPS"
        onChange={handleChange}
        value={equipment.gps_ammount}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />
*/}
      <TextField
        id="gps_vehicle_number"
        name="gps_vehicle_number"
        label="Número de GPS"
        disabled={disabled}
        error={(error !=='' && equipment.gps_vehicle_number ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && equipment.gps_vehicle_number ==='' ) ? 'Debe completar este valor' : ''}
        type="text"
        placeholder="Ingrese el número de GPS"
        onChange={handleChange}
        value={equipment.gps_vehicle_number}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <TextField
        id="gps_detail"
        name="gps_detail"
        label="Detalle de cobertura"
        disabled={disabled}
        type="text"
        placeholder="Ingrese el detalle de cobertura"
        onChange={handleChange}
        value={equipment.gps_detail}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <FormControl className="mt-3 mr-2" style={{minWidth: 200, fontSize: '0.75rem'}} name='gps_is_visible' >GPS es visible?
        <Select native name='gps_is_visible'
            inputProps={{
              name:"gps_is_visible",
              className:"gps_is_visible"
            }}
            style={{minWidth: 200, fontSize: '0.75rem'}}
            disabled={disabled}
            onChange={handleChange}
            value={equipment.gps_is_visible}
            input={<Input id="grouped-native-select" name='gps_is_visible'/>}>
            <option id="Si" value="1">Si</option>
            <option id="No" value="0">No</option>
        </Select> 
      </FormControl>



      <TextField
        id="stereo_code"
        name="stereo_code"
        label="Cod. Stereo"
        disabled={disabled}
        error={(error !=='' && equipment.stereo_code ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && equipment.stereo_code ==='' ) ? 'Debe completar este valor' : ''}
        type="text"
        placeholder="Ingrese el código de stereo"
        onChange={handleChange}
        value={equipment.stereo_code}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='has_duplicated_key' >
        <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Entrega llave duplicado?</InputLabel>
        <Select native name='has_duplicated_key'
            inputProps={{
              name:"has_duplicated_key",
              className:"has_duplicated_key"
            }}
            style={{minWidth: 150, fontSize: '0.75rem'}}
            disabled={disabled}
            onChange={handleChange}
            error={(error !=='' && equipment.has_duplicated_key ==='') ? 'Debe completar este campo' :  false }
            value={equipment.has_duplicated_key}
            input={<Input id="grouped-native-select" name='has_duplicated_key'/>}>
            <option value="" />
            {has_duplicated_key_boolean.map((has_duplicated_key) => <option id={has_duplicated_key.id} value={has_duplicated_key.id}>{has_duplicated_key.name}
          </option>)}
        </Select>
        {(error !=='' && equipment.has_duplicated_key ==='') && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
      </FormControl>


      <TextField
        id="duplicated_key_date"
        name="duplicated_key_date"
        label="Fecha entrega de llave"
        disabled={disabled}
        error={(error !=='' && equipment.duplicated_key_date ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && equipment.duplicated_key_date ==='' ) ? 'Debe completar este valor' : ''}
        type="date"
        placeholder="Ingrese la fecha de entrega"
        onChange={handleChange}
        value={equipment.duplicated_key_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <FormControl className="mt-3 mr-2" style={{minWidth: 200, fontSize: '0.75rem'}} name='fuel_provider' >Seleccione el proveedor de combustible
        <Select native name='fuel_provider'
            inputProps={{
              name:"fuel_provider",
              className:"fuel_provider"
            }}
            style={{minWidth: 200, fontSize: '0.75rem'}}
            disabled={disabled}
            onChange={handleChange}
            value={equipment.fuel_provider}
            input={<Input id="grouped-native-select" name='fuel_provider'/>}>
            <option value="" />
            {fuel_providers.map((fuel_provider) => <option id={fuel_provider.id} value={fuel_provider.id}>{fuel_provider.name}
          </option>)}
        </Select> 
      </FormControl>

      <TextField
        id="fuel_card_number"
        name="fuel_card_number"
        label="Tarjeta de combustible"
        disabled={disabled}
        error={(error !=='' && equipment.fuel_card_number ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && equipment.fuel_card_number ==='' ) ? 'Debe completar este valor' : ''}
        type="text"
        placeholder="Ingrese la tarjeta de combustible"
        onChange={handleChange}
        value={equipment.fuel_card_number}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <TextField
        id="toll_card_number"
        name="toll_card_number"
        label="Tarjeta de peaje"
        disabled={disabled}
        error={(error !=='' && equipment.toll_card_number ==='') ? 'Debe completar este campo' :  false }
        helperText= {(error !=='' && equipment.toll_card_number ==='' ) ? 'Debe completar este valor' : ''}
        type="text"
        placeholder="Ingrese la tarjeta de peaje"
        onChange={handleChange}
        value={equipment.toll_card_number}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />
      {equipment.vehicle_equipment_type_ids.map((val, idx)=>{
        var data = ''
        if (equipment.vehicle_equipment_type_ids[idx].vehicle_equipment_type_id !== '' && equipment.vehicle_equipment_type_ids[idx].vehicle_equipment_type_id !== null && equipment.vehicle_equipment_type_ids[idx].vehicle_equipment_type_id !== undefined){
          data = getEquipmentData(equipment.vehicle_equipment_type_ids[idx].vehicle_equipment_type_id)
        }

        return (
          <React.Fragment>
            <div className="row ml-1">
              {(equipment.vehicle_equipment_type_ids[idx].vehicle_equipment_type_id === '') ?

                <FormControl className="mr-2" style={{minWidth: 200, fontSize: '0.75rem'}} name={'vehicle_equipment_type_id.'+ idx} >
                  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 200, fontSize: '0.75rem'}} >Seleccione el equipamiento</InputLabel>
                  <Select native name={'vehicle_equipment_type_id.'+ idx}
                      inputProps={{
                        name:"vehicle_equipment_type_id."+ idx,
                        className:"vehicle_equipment_type_id."+ idx
                      }}
                      style={{minWidth: 200, fontSize: '0.75rem'}}
                      disabled={disabled}
                      onChange={handleChange}
                      error={(error !=='' && equipment.vehicle_equipment_type_id ==='') ? 'Debe completar este campo' :  false }
                      value={equipment.vehicle_equipment_type_id}
                      input={<Input id="grouped-native-select" name={'vehicle_equipment_type_id.'+ idx}/>}>
                      <option value="" />
                      {equipment_types.map((equipment_type) => <option id={equipment_type.id} value={equipment_type.id}>{equipment_type.name}
                    </option>)}
                  </Select> 
                  {(error !=='' && equipment.vehicle_equipment_type_id ==='') && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
                </FormControl>
              :
                <TextField
                  id={"vehicle_equipment_type_id."+ idx}
                  name={"vehicle_equipment_type_id."+ idx}
                  label="Equipamiento"
                  disabled={true}
                  type="text"
                  value={data.name}
                  margin="normal"
                  className="mr-2 "
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                />
              }
              <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   

                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleRemoveItem(e, idx)}}
                disabled={(equipment.vehicle_equipment_type_ids.length ==1) ? true : false} >
                  <RemoveIcon className={classes.deleteIcon} />
                </IconButton>
                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleAddItem(e)}}>
                      <AddIcon className={classes.deleteIcon}/>
                </IconButton>
              </div>
            </div>
          </React.Fragment>
        )
      })
      }
    </React.Fragment>
    )
}
export default Eqipment;
